import { configureStore } from '@reduxjs/toolkit'
import ChatAiRootSlice from '../advanced/ChatAi/store/root'
import ChatMenuSlice from '../advanced/ChatMenu/store'

export const store = configureStore({
  reducer: {
    chatAiRoot: ChatAiRootSlice,
    chatMenu: ChatMenuSlice
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
